import React from 'react';

// todo: change link to production
const ErrorPage = () => {
  var url = process.env.REACT_APP_HOME_LOAN_URL;
  return (
    <div className="occu-form">
      <h5>
        Oops! Something went wrong. We apologize for the inconvenience. Please click <a href={url}>here</a> to get back
        on track.
      </h5>
    </div>
  );
};

export default ErrorPage;
